import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminHeaderComponent } from '../../shared/widgets/admin-header/admin-header.component';
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../core/store';
import { Subscription } from 'rxjs';
import { getSettingsStore } from '../../core/store/selectors/settings.selectors';
import { AdminSidemenuComponent } from '../../shared/widgets/admin-sidemenu/admin-sidemenu.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NzLayoutModule,
    AdminHeaderComponent,
    AdminSidemenuComponent,
    NzToolTipModule,
  ],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css',
})
export class AdminLayoutComponent {
  store = inject(Store<AppState>);

  settingsStoreSub: Subscription;

  isCollapsed = false;

  // ngOnInit(): void {
  //   this.settingsStoreSub = this.store
  //     .pipe(select(getSettingsStore))
  //     .subscribe((settingsStore) => {
  //       this.isCollapsed = settingsStore.sideMenuCollapsedState;
  //     });
  // }

  // ngOnDestroy(): void {
  //   if (this.settingsStoreSub) this.settingsStoreSub.unsubscribe();
  // }
}
